import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

// Define the parts for EmptyState component
// Based on Saas UI structure: container, description, title, icon, actions
const parts = ['container', 'description', 'title', 'icon', 'actions'] as const;

const { defineMultiStyleConfig, definePartsStyle } =
  createMultiStyleConfigHelpers(parts);

const baseStyle = definePartsStyle(() => ({
  container: {
    px: 4,
    py: 10,
    border: '1px solid',
    borderColor: 'border.light',
    rounded: '2xl',
    textAlign: 'center',
  },
  title: {
    marginTop: 0,
  },
  description: {
    color: 'fonts.primary',
    opacity: 0.6,
    fontSize: 'sm', // secondaryRegular size
    fontWeight: 'normal', // secondaryRegular weight
    lineHeight: '5', // secondaryRegular lineHeight
  },
}));

export const emptyStateTheme = defineMultiStyleConfig({
  baseStyle,
});
